(function ($) {

    $(document).on('click', '[mda-readmore]', function () { 
        var id = $(this).attr('mda-readmore');
        $(this).remove();
        $("[mda-readmore-id='" + id + "']").css('display', 'block');
    });

})(jQuery);